import React, { Component } from "react";
import axios from "../../utils/axiosInstance";
import Swal from "sweetalert2";

class GoogleSiteSetups extends Component {
  state = {
    user_id: localStorage.getItem("user_id"),
    user_role: localStorage.getItem("user_role"),
    google_site_verification: "",
    google_search_console: "",
    google_tag_manager_status: 0, // 0 or 1
    google_tag_manager_id: "",
    loading: false,
  };

  // Handle text/textarea inputs
  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  // Handle checkbox input
  handleCheckbox = (e) => {
    this.setState({ google_tag_manager_status: e.target.checked ? 1 : 0 });
  };

  // Fetch existing Google Site Settings
  fetchExistingSettings = async () => {
    const { user_id, user_role } = this.state;
    if (!user_id || !user_role) return;

    try {
      this.setState({ loading: true });
      const res = await axios.get("/get_google_site_setting", {
        params: { user_id, user_role },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      if (res.data.data) {
        this.setState({
          google_site_verification: res.data.data.google_site_verification || "",
          google_search_console: res.data.data.google_search_console || "",
          google_tag_manager_status: res.data.data.google_tag_manager_status == 1 ? 1 : 0,
          google_tag_manager_id: res.data.data.google_tag_manager_id || "",
        });
      }
    } catch (err) {
      console.error(err);
    } finally {
      this.setState({ loading: false });
    }
  };

  componentDidMount() {
    this.fetchExistingSettings();
  }

  // Save or Update
  handleSubmit = async (e) => {
    e.preventDefault();
    const {
      user_id,
      user_role,
      google_site_verification,
      google_search_console,
      google_tag_manager_status,
      google_tag_manager_id,
    } = this.state;

    if (!user_id || !user_role) {
      Swal.fire("Error", "User ID or role not found", "error");
      return;
    }

    try {
      this.setState({ loading: true });
      const res = await axios.post(
        "/google_site_settings",
        {
          user_id,
          user_role,
          google_site_verification,
          google_search_console,
          google_tag_manager_status,
          google_tag_manager_id,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      Swal.fire("Success", res.data.message, "success");
    } catch (err) {
      console.error(err);
      Swal.fire(
        "Error",
        err.response?.data?.message || "Something went wrong",
        "error"
      );
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const {
      google_site_verification,
      google_search_console,
      google_tag_manager_status,
      google_tag_manager_id,
      loading,
    } = this.state;

    return (
      <div className="pc-container">
        <div className="pc-content">
          <div className="row">
            <div className="col-12">
              <div className="card shadow-sm border-0 rounded-4">
                <div className="card-body p-4">
                  <form onSubmit={this.handleSubmit}>
                    <h4 className="fw-semibold text-uppercase text-center mb-3">
                      Google Site Setups
                    </h4>
                    <p className="fw-semibold text-center mb-3">
                      Add Google Site Verification, Search Console, and Tag Manager ID
                    </p>

                    {/* Google Site Verification */}
                    <div className="mb-3">
                      <label className="form-label">
                        Google Site Verification <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        name="google_site_verification"
                        className="form-control"
                        placeholder="Enter Google Site Verification"
                        value={google_site_verification}
                        onChange={this.handleChange}
                        required
                      />
                    </div>

                    {/* Google Search Console */}
                    <div className="mb-3">
                      <label className="form-label">Google Search Console</label>
                      <textarea
                        className="form-control"
                        name="google_search_console"
                        rows={3}
                        placeholder="Enter Google Search Console Verification token"
                        value={google_search_console}
                        onChange={this.handleChange}
                      ></textarea>
                    </div>

                    {/* Google Tag Manager Checkbox */}
                    <div className="form-check mb-3">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        checked={google_tag_manager_status === 1}
                        onChange={this.handleCheckbox}
                        id="tagManagerCheckbox"
                      />
                      <label className="form-check-label" htmlFor="tagManagerCheckbox">
                        Manage Facebook Pixel with Tag Manager Data layer?
                      </label>
                    </div>

                    {/* Google Tag Manager Id */}
                    <div className="mb-3">
                      <label className="form-label">Google Tag Manager Id</label>
                      <input
                        type="text"
                        name="google_tag_manager_id"
                        className="form-control"
                        placeholder="Enter Google Tag Manager Id"
                        value={google_tag_manager_id}
                        onChange={this.handleChange}
                      />
                    </div>

                    {/* Save Button */}
                    <div className="text-end mt-4">
                      <button
                        type="submit"
                        className="btn btn-primary px-4"
                        disabled={loading}
                      >
                        {loading ? "Saving..." : "Save"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default GoogleSiteSetups;
